@defer (when isOpenedOneyModal) {
  <sd-modal-default [(isOpened)]="isOpenedOneyModal" (isOpenedChange)="modalClosed($event)" [hasHeader]="false">
    <div sd-modal-body id="wc-oney-modal">
      @if (isSimulationUnavailable) {
        <div>{{ 'oney.simulation.unavailable' | translate }}</div>
      } @else {
        <span class="logo-img">
          <svg
            class="logo-img__oneyLogo"
            version="1.1"
            id="Calque_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 163.9 52.7"
            style="enable-background: new 0 0 163.9 52.7"
            xml:space="preserve"
          >
            <title>logo_oney</title>
            <g id="_x32_331473d-89dd-4e14-acef-0ffb140d5ce1">
              <g id="d92fae8c-cbd5-4322-8285-55f7b114ac5d">
                <path
                  fill="#81BC00"
                  class="st0"
                  d="M20.4,0C9.2-0.1,0.1,8.9,0,20c0,0.2,0,0.3,0,0.5C-0.1,31.7,8.8,40.9,20,41c0.1,0,0.3,0,0.4,0
                  c11.2,0.1,20.3-8.9,20.4-20.1c0-0.1,0-0.3,0-0.4C41,9.3,32,0.2,20.9,0C20.7,0,20.6,0,20.4,0 M20.4,34c-7.3,0-13.2-6-13.2-13.4
                  v-0.1C7,13.2,12.8,7.1,20.1,6.9s13.4,5.5,13.6,12.8c0,0.2,0,0.5,0,0.7C33.7,27.9,27.8,33.9,20.4,34C20.5,34,20.4,34,20.4,34
                  M163.9,0l-15.6,38.1l-3.9,9.4l-2.1,5.2h-7.7l6-14.6L124.7,0h8.1l11.7,28.6L156.2,0H163.9z M63.3,6.8c-7.2,0-10.9,3.9-10.9,11.5
                  v22.6H45V17.8c0.1-4.1,0.8-6.9,2.4-9.6c2-3,6.6-8.1,15.8-8.1S77.1,5.2,79,8.2c1.7,2.9,2.6,6.3,2.4,9.6V41H74V18.3
                  C74.2,10.6,70.6,6.8,63.3,6.8 M93.6,16.8c1.4-6.7,7.9-10.9,14.6-9.5c4.8,1,8.5,4.7,9.5,9.5H93.6z M125.5,20
                  c0-10.9-8.8-19.8-19.8-19.9c-11.2,0-19.9,9-19.9,20.4c0,5.3,2.1,10.5,5.8,14.4c3.6,3.9,8.7,6.1,14,6.1c6,0,14.5-2.9,18.5-11.1
                  c0-0.1,0.1-0.2,0.1-0.3h-8.1v0.1c-2.6,2.8-6.3,4.4-10.2,4.4c-6.2-0.1-11.4-4.6-12.5-10.7h32C125.4,22.5,125.5,21,125.5,20"
                />
              </g>
            </g>
          </svg>
        </span>

        <span class="oney-modal__body--title">
          {{ 'oney.simulation.title' | translate }}
        </span>

        <div class="oney-modal__data">
          <!-- DESKTOP TABS -->
          @if ({
            isDesktop: isDesktop$ | async,
            isTablet: isTablet$ | async,
            isMobile: isMobile$ | async
            }; as userDevice) {
            @if (userDevice.isMobile === false && userDevice.isTablet === false) {
              <ul class="oney-modal__tabs-desktop">
                @for (simulation of currentSimulation; track simulation) {
                  <li
                    class="tab-desktop"
                    (click)="setActiveTab($index, false, simulation.type)"
                    [ngClass]="{ active: $index === activeTab || (activeTab === -1 && $first) }"
                  >
                    {{ simulation.business_transaction_details.customer_label }}
                  </li>
                }
              </ul>
            }
            <div class="oney-modal__instalments">
              @for (simulation of currentSimulation; track simulation) {
                <div class="tab-container" [ngClass]="{ isMobile: userDevice.isMobile || userDevice.isTablet }">
                  @if (($index === activeTab) || (!userDevice.isMobile && !userDevice.isTablet && activeTab === -1 && $first)) {
                    <div class="content">
                      <ul class="oney-modal__instalment--list">
                        <li class="oney-modal__instalment--item">
                          <sd-html tag="span" [html]="'oney.simulation.instalment.total' | translate: {
                            total_amount: simulation.paymentAmount.formattedValue
                          }" />
                        </li>
                        @for (instalment of simulation.instalments; track instalment) {
                          @if ($first) {
                            <li class="oney-modal__instalment--item">
                              <sd-html tag="span" [html]="'oney.simulation.instalment.apport_first'| translate: {
                                date_: (instalment.collection_date | date: 'dd/MM/yyyy'),
                                amount: instalment.instalmentAmount.formattedValue
                              }" />
                            </li>
                          } @else {
                            <li class="oney-modal__instalment--item">
                              <sd-html tag="span" [html]="'oney.simulation.instalment.apport' | translate: {
                                date_: (instalment.collection_date | date: 'dd/MM/yyyy'),
                                i: $index,
                                amount: instalment.instalmentAmount.formattedValue
                              }" />
                            </li>
                          }
                        }
                        <li class="oney-modal__instalment--item">
                          <sd-html tag="span" [html]="'oney.simulation.instalment.totalWithFinancement' | translate: {
                            total: simulation.totalCost.formattedValue,
                            free: simulation.administrationFeeAmount.formattedValue
                          }" />
                        </li>
                        <li class="oney-modal__instalment--item">
                          <sd-html tag="span" [html]="'oney.simulation.instalment.nominal' | translate: {
                            nominal: simulation.nominal_annual_percentage_rate
                          }" />
                          <br />
                          <sd-html tag="span" [html]="'oney.simulation.instalment.global' | translate: {
                            global: simulation.effective_annual_percentage_rate
                          }" />
                        </li>
                      </ul>
                    </div>
                  }
                  @if (userDevice.isMobile || userDevice.isTablet) {
                    <div class="tab-mobile" (click)="setActiveTab($index, true,simulation.type)">
                      <div>{{ simulation.business_transaction_details.customer_label }}</div>
                      @if ($index === activeTab) {
                        <i class="up icon-up">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
                            <g
                              id="Atomes-/-Icons-/-arrows-/-arrow-top"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                              >
                              <path
                                d="M15.4127684,7 L15.586253,7 L15.586253,17 C15.586253,17.5522847 15.1385377,18 14.586253,18 C14.0339682,18 13.586253,17.5522847 13.586253,17 L13.586253,9 L5.41276836,9 C4.86048361,9 4.41276836,8.55228475 4.41276836,8 C4.41276836,7.44771525 4.86048361,7 5.41276836,7 L15.4127684,7 Z"
                                id="arrow-top"
                                fill="#242F3A"
                                transform="translate(9.999511, 12.500000) scale(-1, 1) rotate(-45.000000) translate(-9.999511, -12.500000) "
                              />
                            </g>
                          </svg>
                        </i>
                      } @else {
                        <i class="down icon-down">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
                            <g
                              id="Atomes-/-Icons-/-arrows-/-arrow-bottom"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                              >
                              <path
                                d="M15.4127684,2 L15.586253,2 L15.586253,12 C15.586253,12.5522847 15.1385377,13 14.586253,13 C14.0339682,13 13.586253,12.5522847 13.586253,12 L13.586253,4 L5.41276836,4 C4.86048361,4 4.41276836,3.55228475 4.41276836,3 C4.41276836,2.44771525 4.86048361,2 5.41276836,2 L15.4127684,2 Z"
                                id="arrow-bottom"
                                fill="#242F3A"
                                transform="translate(9.999511, 7.500000) scale(-1, -1) rotate(-45.000000) translate(-9.999511, -7.500000) "
                              />
                            </g>
                          </svg>
                        </i>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>

        <!-- MENTIONS-->
        <div class="oney-modal__mentions">
          @if ((currentSimulationType!=='x12' && currentSimulationType!=='x10')) {
            <span class="mentions-title">
              {{ 'oney.simulation.footer.title' | translate }}
            </span>
          }
          <span
            class="mentions-body"
            [ngClass]='(currentSimulationType==="x12" || currentSimulationType==="x10") ? "body--large" : "body--small"'
          >
            {{ paragraph1 }}
          </span>
          <span
            class="mentions-body"
            [ngClass]='(currentSimulationType==="x12" || currentSimulationType==="x10") ? "body--large" : "body--small"'
          >
            {{ paragraph2 }}
          </span>
          <span class="mentions-body body--small">{{ paragraph3 }}</span>
          <div>
            @switch (currentSimulationType) {
              @case ('x12') {
                <div>
                  <ng-container *ngTemplateOutlet="oney10x12xlogo" />
                </div>
              }
              @case ('x10') {
                <div>
                  <ng-container *ngTemplateOutlet="oney10x12xlogo" />
                </div>
              }
              @default {
                <div>
                  <svg class="oney-modal__signature" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 30">
                    <g fill="#8bbd06">
                      <path
                        d="M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0ZM13.35,20.1a4.84,4.84,0,0,1-3.15,1.2,7,7,0,0,1-3.15-.6V18.15c.6.3,1.2.45,1.5.6a4.62,4.62,0,0,0,1.5.15,2.24,2.24,0,0,0,1.5-.45,1.85,1.85,0,0,0,.6-1.2,1.36,1.36,0,0,0-.6-1.2,2.53,2.53,0,0,0-1.5-.45A2.93,2.93,0,0,0,9,15.75L8.1,14.4l3-2.85H6.9V9.45h6.9V11.7l-2.55,2.1h.15a2.7,2.7,0,0,1,2.25,1,3.68,3.68,0,0,1,.9,2.4A3.84,3.84,0,0,1,13.35,20.1Zm8.1.9L20,18.6,18.45,21H15.9l2.85-4.2-2.7-4.2h2.7l1.35,2.1,1.35-2.1H24l-2.7,4L24.15,21Z"
                      />
                      <polygon points="47.32 17.25 47.32 13.35 44.92 17.25 47.32 17.25" />
                      <path
                        d="M51.07,0a15,15,0,1,0,15,15A15,15,0,0,0,51.07,0Zm.15,19.2H49.57V21h-2.4V19.2h-5.1V17.85l5.1-8.4h2.4V17.1h1.65Zm6.6,1.8-1.5-2.4L54.82,21H52.27l2.85-4.2-2.7-4.2h2.7l1.35,2.1,1.35-2.1h2.55l-2.7,4L60.52,21Z"
                      />
                      <path
                        d="M79.08,8a7.13,7.13,0,0,0-4.93,2,6.75,6.75,0,0,0-2,4.92,6.62,6.62,0,0,0,3.39,6.16,7.25,7.25,0,0,0,7.08,0A6.8,6.8,0,0,0,86,14.92,7.12,7.12,0,0,0,84,10,7.41,7.41,0,0,0,79.08,8Zm0,11.54a4.4,4.4,0,0,1-3.23-1.39,3.74,3.74,0,0,1-1.23-3.23,4.46,4.46,0,0,1,8.92,0,5,5,0,0,1-1.23,3.23A4.17,4.17,0,0,1,79.08,19.54ZM128,8l-5.38,13.08-1.39,3.23L120.62,26H118l2-4.92L114.62,8h2.76l4,9.85,4-9.85ZM93.69,10.31c-2.46,0-3.69,1.38-3.69,4V22H87.54V14.15a7.19,7.19,0,0,1,.77-3.23A6.46,6.46,0,0,1,93.69,8a6.71,6.71,0,0,1,5.39,2.77A4.88,4.88,0,0,1,99.85,14v7.85H97.38v-7.7C97.38,11.69,96.15,10.31,93.69,10.31ZM104,13.69a4.24,4.24,0,0,1,8.31,0Zm10.92,1.08a6.85,6.85,0,0,0-13.69.15,7.43,7.43,0,0,0,2,4.93A6.32,6.32,0,0,0,108,22a7,7,0,0,0,6.31-3.85V18h-2.77A5,5,0,0,1,108,19.54a4.44,4.44,0,0,1-4.31-3.69h10.93c.3-.16.3-.62.3-1.08Z"
                      />
                    </g>
                  </svg>
                </div>
              }
            }
          </div>
        </div>

        <!-- FOOTER -->
        <div class="oney-modal__footer">
          <span class="mentions-body body--small">
            <sd-html innerClass="mentions-body body--fade" [html]="footer" tag="span" />
          </span>
        </div>
      }

      <!-- DATA -->

      <ng-template #oney10x12xlogo>
        <svg class="oney-modal__signature__12x" xmlns="http://www.w3.org/2000/svg" viewBox="20 0 50 93.54">
          <defs>
            <style>
              .cls-1 { fill: #fff !important; }
              .cls-2 { fill: #84bd06;}
            </style>
          </defs>
          <g>
            <path
              class="cls-2"
              d="M46.79,22.79c-13.24-.01-23.99,10.72-24,23.96-.01,13.24,10.72,23.99,23.96,24,13.24,.01,23.99-10.72,24-23.96,0,0,0-.01,0-.02,.14-13.1-10.37-23.84-23.48-23.98-.16,0-.32,0-.49,0"
            />
            <g>
              <path class="cls-1" d="M28.2,40.46c3.48,0,4.25-1,4.25-3.15h3.66v17.91h-4.22v-11.84h-3.69v-2.92Z" />
              <path
                class="cls-1"
                d="M38.57,43.33c0-3.54,2.87-6.41,6.41-6.41,.13,0,.26,0,.39,.01,3.56-.22,6.62,2.48,6.84,6.04,0,.12,.01,.24,.01,.36v5.88c-.03,3.56-2.94,6.43-6.5,6.41-.12,0-.24,0-.36-.01-3.53,.22-6.58-2.47-6.79-6,0-.13-.01-.26-.01-.39v-5.88Zm9.52,0c.11-1.48-1.01-2.77-2.49-2.88-1.48-.11-2.77,1.01-2.88,2.49,0,.13,0,.26,0,.39v5.88c-.11,1.48,1.01,2.77,2.49,2.88,1.48,.11,2.77-1.01,2.88-2.49,0-.13,0-.26,0-.39v-5.88Z"
              />
              <path
                class="cls-1"
                d="M66.09,55.23h-4.53l-2.02-3.58-2.02,3.58h-4.53l4.25-6.22-4.18-6.12h4.53l1.94,3.48,1.95-3.48h4.53l-4.14,6.12,4.22,6.22Z"
              />
            </g>
          </g>
        </svg>

        <svg class="oney-modal__signature__12x" xmlns="http://www.w3.org/2000/svg" viewBox="15 0 60 93.54">
          <defs>
            <style>
              .cls-1 { fill: #fff !important; }
              .cls-2 { fill: #84bd06; }
            </style>
          </defs>
          <g>
            <path
              class="cls-2"
              d="M46.79,22.83c-13.23-.01-23.96,10.7-23.97,23.93-.01,13.23,10.7,23.96,23.93,23.97,13.23,.01,23.96-10.7,23.97-23.93,0,0,0-.01,0-.02,.14-13.09-10.35-23.81-23.44-23.95-.16,0-.33,0-.49,0"
            />
            <g>
              <path class="cls-1" d="M28.85,40.47c3.48,0,4.24-1,4.24-3.14h3.65v17.89h-4.22v-11.83h-3.68v-2.91Z" />
              <path
                class="cls-1"
                d="M43.78,45.97c2.1-1.25,3.76-2.1,3.76-3.88,.1-1.02-.64-1.92-1.66-2.02-.13-.01-.26-.01-.39,0-1.28,0-2.27,.74-2.27,2.61h-4.11c0-3.25,2.3-5.72,6.36-5.72,3.3,0,6.13,1.64,6.13,5.42,0,3.01-2.91,4.83-4.68,5.88-2.45,1.64-3.12,2.2-3.12,3.63h7.66v3.35h-12.42c0-5.81,1.97-7.55,4.73-9.25Z"
              />
              <path
                class="cls-1"
                d="M65.44,55.21h-4.52l-2.02-3.58-2.02,3.58h-4.52l4.24-6.21-4.16-6.11h4.52l1.94,3.48,1.94-3.48h4.52l-4.14,6.1,4.22,6.21Z"
              />
            </g>
          </g>
        </svg>

        <svg class="oney-modal__signature__12x__oney" xmlns="http://www.w3.org/2000/svg" viewBox="15 0 230 109.61">
          <defs>
            <style>
              .cls-3 { fill: #84bd06 !important;}
            </style>
          </defs>
          <path
            class="cls-3"
            d="M170.77,47.32c-.08-12.85-10.45-23.29-23.14-23.29s-23.29,10.48-23.29,23.87c0,6.28,2.41,12.25,6.74,16.8,4.4,4.61,10.22,7.15,16.4,7.15,7.06,0,16.95-3.39,21.65-13,.1-.2,.12-.31,.12-.31h-9.46l-.06,.07c-2.54,3.04-7.34,5.1-11.91,5.1-5.8,0-12.76-3.83-14.67-12.47h37.44c.08-.89,.18-2.68,.18-3.91Zm-37.35-3.71c1.15-5.79,6.69-11.44,14.14-11.44s12.97,5.65,14.11,11.44h-28.25Zm-35.34-11.71c-8.44,0-12.72,4.52-12.72,13.47v26.5h-8.66v-27.12c.08-4.76,.92-8.12,2.86-11.28,2.3-3.54,7.75-9.51,18.52-9.51s16.22,5.96,18.51,9.51c1.92,3.16,2.79,6.52,2.84,11.28v27.12h-8.66v-26.5c0-8.95-4.26-13.47-12.7-13.47m117.73-7.92l-18.26,44.55-4.51,11.03-2.49,6.1h-9l6.99-17.11-18.66-44.56h9.52l13.66,33.5,13.69-33.5h9.08ZM47.84,63.72c-8.52,0-15.46-6.93-15.46-15.77s6.94-15.79,15.46-15.79,15.43,6.95,15.43,15.79-6.97,15.77-15.43,15.77m0-39.75c-13.4,0-23.9,10.53-23.9,23.98s10.5,23.98,23.9,23.98,23.86-10.54,23.86-23.98-10.49-23.98-23.86-23.98"
          />
        </svg>
      </ng-template>
    </div>
  </sd-modal-default>
}